import {
  JOB_LIST,
  JOB_LIST_SUCCESSFUL,
  JOB_LIST_FAILED,
  JOB_SEARCH,
  JOB_SEARCH_SUCCESSFUL,
  JOB_SEARCH_FAILED,
  JOB_DISTRIBUTION,
  JOB_DISTRIBUTION_SUCCESSFUL,
  JOB_DISTRIBUTION_FAILED,
  GET_JOB_STATUS,
  GET_JOB_STATUS_SUCCESSFUL,
  GET_JOB_STATUS_FAILED,
  GET_MANAGE_LINK,
  GET_MANGE_LINK_SUCCESS,
  GET_MANGE_LINK_FAIL,
  JOB_DELETE,
  JOB_DELETE_FAILED,
  JOB_DELETE_SUCCESSFUL,
  GET_DATA,
  GET_SEARCH_DATA,
  GET_JOBS_BY_FILTER,
  GET_JOBS_BY_FILTER_SUCCESS,
  GET_JOBS_BY_FILTER_FAILED,
  GET_JOBS_BY_SEARCH,
  GET_JOBS_BY_SEARCH_SUCCESS,
  GET_JOBS_BY_SEARCH_FAILED,
  GET_JOBS_BY_LIST,
  GET_JOBS_BY_LIST_SUCCESS,
  GET_JOBS_BY_LIST_FAILED

} from "./actionTypes"

export const jobList = user => {
  return {
    type: JOB_LIST,
    payload: { user },
  }
}

export const jobListSuccessful = user => {
  return {
    type: JOB_LIST_SUCCESSFUL,
    payload: user,
  }
}

export const jobListFailed = user => {
  return {
    type: JOB_LIST_FAILED,
    payload: user,
  }
}
export const jobSearch = user => {
  return {
    type: JOB_SEARCH,
    payload: {user},
  }
}
export const jobSearchListSuccessful = user => {
  return {
    type: JOB_SEARCH_SUCCESSFUL,
    payload: user,
  }
}

export const jobSearchListFailed = user => {
  return {
    type: JOB_SEARCH_FAILED,
    payload: user,
  }
}

export const jobDistribution = (distributionJobId) => {
  return {
    type: JOB_DISTRIBUTION,
    payload: {distributionJobId},
  }
}

export const jobDistributionSuccess = (distributionSuccessMessage) =>{
  return{
    type: JOB_DISTRIBUTION_SUCCESSFUL,
    payload: {distributionSuccessMessage},
  }
} 

export const jobDistributionFail = (distributionFailMessage) =>{
  return{
    type: JOB_DISTRIBUTION_FAILED,
    payload: distributionFailMessage,
  }
} 



export const getJobStatusData = (jobId) => {
  return {
    type: GET_JOB_STATUS,
    payload: {jobId},
  }
}


export const getJobStatusDataSuccessful = (jobStatusData) => {
  return {
    type: GET_JOB_STATUS_SUCCESSFUL,
    payload: {jobStatusData},
  }
}

export const getJobStatusDataFailed = (message) =>{
  return{
  type: GET_JOB_STATUS_FAILED,
  payload: {message}
}
}


export const getMangeLink = (jtJobId ) => {
  return {
    type: GET_MANAGE_LINK,
    payload: {jtJobId },
  }
}


export const getMangeLinkSuccessful = ( mangeLinkData) => {
  return {
    type: GET_MANGE_LINK_SUCCESS,
    payload: { mangeLinkData},
  }
}


export const getMangeLinkFailed = (message) =>{
  return{
  type: GET_MANGE_LINK_FAIL,
  payload: {message}
}
}



export const deleteJob = user => {
  return {
    type: JOB_DELETE,
    payload: { user },
  }
}

export const deleteJobSuccessful = user => {
  return {
    type: JOB_DELETE_SUCCESSFUL,
    payload: user,
  }
}
export const deleteJobFailed = user => {
  return {
    type:  JOB_DELETE_FAILED,
    payload: user,
  }
}

export const getJobData = user => {
  return {
    type: GET_DATA,
    payload: { user },
  }
}
  export const getSearchJobData = user => {
    return {
      type: GET_SEARCH_DATA,
      payload: { user },
    }
  }

  export const getJobsByFilter=(data)=>{
    return {
      type:GET_JOBS_BY_FILTER,
      payload:{data}
    }
  }

  export const getJobsByFilterSuccess=(data)=>{
    return{
      type:GET_JOBS_BY_FILTER_SUCCESS,
      payload:data

    }
  }

  export const getJobsByFilterFailed=(error)=>{
    return{
      type:GET_JOBS_BY_FILTER_FAILED,
      payload:error
    }

  }

  export const getJobsBySearch=(data)=>{
    return {
      type:GET_JOBS_BY_SEARCH,
      payload:{data}
    }
  }

  export const getJobsBySearchSuccess=(data)=>{
    return{
      type:GET_JOBS_BY_SEARCH_SUCCESS,
      payload:data

    }
  }

  export const getJobsBySearchFailed=(error)=>{
    return{
      type:GET_JOBS_BY_SEARCH_FAILED,
      payload:error
    }

  }

  export const getJobsByList=(data)=>{
    return {
      type:GET_JOBS_BY_LIST,
      payload:{data}
    }
  }

  export const getJobsByListSuccess=(data)=>{
    return{
      type:GET_JOBS_BY_LIST_SUCCESS,
      payload:data

    }
  }

  export const getJobsByListFailed=(error)=>{
    return{
      type:GET_JOBS_BY_LIST_FAILED,
      payload:error
    }

  }

